import {
    AHOC_FORM_INVALID_TRANSITION_BASIC_DETAILS,
    AHOC_FORM_VALID_TRANSITION_BASIC_DETAILS,
    PURCHASE_PERSONAL_DETAILS_EDIT,
    AHOC_BASIC_DETAILS_SET_VALID,
    AHOC_BASIC_DETAILS_SET_VALUE,
    AHOC_BASIC_DETAILS_SET_VALUE_WITHOUT_VALIDATION,
} from '../../actions/allsureHomeClaim/basicDetails';
import { FIELD_STATUS, FORM_STATUS } from '../status';

export const initBasicDetails = {
    formStatus: FORM_STATUS.INVALID,
    isPurchasePersonalDetailsEdit: false,
    form: {
        categoryType: { value: null, error: null, status: null ,displayValue: null},
        policyNumber: { value: null, error: null, status: null ,displayValue: null},
        fullName: { value: null, error: null, status: null ,displayValue: null},     
        //Contact Details
        mobileNumber: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        privacyNotice: { value: null, error: null, status: null ,displayValue: null},
        tnc: { value: null, error: null, status: null ,displayValue: null},
        consentNotice: { value: null, error: null, status: null ,displayValue: null},
    },
};
export default (state = initBasicDetails, action) => {
    const trimField = (value) => (value ? value.trim() : value);
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    // if ( CLAIMENT_DETAILS_SET_VALUE) {
    switch (action.type) {
        case AHOC_FORM_VALID_TRANSITION_BASIC_DETAILS:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case AHOC_FORM_INVALID_TRANSITION_BASIC_DETAILS:
            return { ...state, formStatus: FORM_STATUS.INVALID };
        case AHOC_BASIC_DETAILS_SET_VALUE:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                value: action.value.value,
                displayValue: action.value.displayValue
            }));
        case AHOC_BASIC_DETAILS_SET_VALUE_WITHOUT_VALIDATION:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                value: action.value.value,
                displayValue: action.value.value,
                error: null,
                status: null,
            }));

        case AHOC_BASIC_DETAILS_SET_VALID:
            const { fieldType, error } = action;
            return updateFormField(fieldType, (field) => ({
                ...field,
                error: error,
                status: mapError(error),
            }));
        case PURCHASE_PERSONAL_DETAILS_EDIT:
            return { ...state, isPurchasePersonalDetailsEdit: action.value };
        default:
            return state;
        // }
    }
};
